module.exports = __webpack_public_path__ + "static/pos-9cd6467373f1bce99ca2d29bae444d3f.webm";